import React from "react";
import styled from "styled-components";
import { useTheme } from "styled-components";
import { ThemedText } from "@components/ThemedText";
import { cardStroke } from "@styles/cardStroke";
import RightIcon from "@icon-park/react/es/icons/Right";
import { navigate } from "gatsby";
import { useSelector } from "react-redux";
import { investorSelector } from "@state/investor/investor.selectors";
import useAnalytics from "@helpers/useAnalytics";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  ${cardStroke}
  border-radius: 8px;
  cursor: pointer;
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

interface IfIsaTransferBannerCardProps {
  onClick?: () => void;
}

export const IfIsaTransferBannerCard = ({
  onClick,
}: IfIsaTransferBannerCardProps) => {
  const theme = useTheme();
  const investor = useSelector(investorSelector);
  const fireIfIsaTransferInCtaClicked = useAnalytics(
    "ifIsaTransferInCtaClicked"
  );
  const triggerIfIsaTransferInCtaClicked = async () => {
    (await fireIfIsaTransferInCtaClicked)({
      isMember: investor?.isMember,
      user_id: investor?.id,
    });
  };

  const handleClick = () => {
    triggerIfIsaTransferInCtaClicked();
    onClick?.();
    navigate("/app/if-isa/transfers");
  };

  return (
    <Container onClick={handleClick}>
      <TextColumn>
        <ThemedText type="U16" color="SLATE700">
          TRANSFER YOUR EXTERNAL ISA
        </ThemedText>
        <ThemedText type="P14" color="SLATE600">
          Transfer an existing ISA and consolidate your investments into your
          Cur8 IF-ISA.
        </ThemedText>
      </TextColumn>
      <RightIcon size={24} fill={theme.colors.ui.icon.secondary} />
    </Container>
  );
};
